var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forum-list"},[_c('h2',{staticClass:"list-title"},[_c('router-link',{attrs:{"to":{name: 'Category', params: {id : _vm.category['.key']}}}},[_vm._v("\n          "+_vm._s(_vm.category.name)+"\n        ")]),_vm._v(" "),_c('a',{attrs:{"href":"#"}})],1),_vm._v(" "),_c('ForumList',{attrs:{"forums":_vm.categoryForums}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f4ef32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoryListItem.vue
// module id = J/FS
// module chunks = 1